import Document24 from '@carbon/icons-react/es/document/24';
import { Col, Row, Typography } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  TemplateCard,
  TemplateCardIconWrapper,
} from 'components/atoms/card/template-card';
import { Drawer } from 'components/atoms/drawer';
import { IconShell } from 'components/atoms/icon-shell';
import { PageLoading } from 'components/atoms/loading';
import { DocumentTemplatesEmptyState } from 'components/organisms/spaces/space-tab/new-tab/document-templates-empty-state';
import { TemplateObjectType, Template } from 'data/templates/api';
import { DocumentTemplatesAPI } from 'data/templates/documents/api';

const Document = styled(Document24)`
  fill: var(--blue-40);
`;

const { Paragraph } = Typography;

export const DocumentTemplateList: FC<{
  visible: boolean;
  onClose(): void;
  onChooseTemplate(template: Template): void;
}> = ({ visible, onClose, onChooseTemplate }) => {
  const [templates, setTemplates] = useState<Template[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (visible) {
      /* TODO:: Move to useQuery */
      DocumentTemplatesAPI.findAll().then((_templates) => {
        setTemplates(_templates);
        setLoading(false);
      });
    }
  }, [visible]);

  return (
    <Drawer
      placement="right"
      closable
      onClose={onClose}
      visible={visible}
      width={688}
    >
      <h5>
        <FormattedMessage id="templates.documents" />
      </h5>
      <Row gutter={[16, 16]}>
        {loading ? (
          <PageLoading />
        ) : templates.length > 0 ? (
          templates.map((template) => (
            <Col>
              <TemplateCard
                onClick={() => onChooseTemplate(template)}
                data-cy={`document_template.${template.templateName}`}
              >
                <TemplateCardIconWrapper type={TemplateObjectType.Document}>
                  <IconShell icon={<Document />} />
                </TemplateCardIconWrapper>
                <Paragraph ellipsis={{ rows: 2 }}>
                  {template.templateName}
                </Paragraph>
              </TemplateCard>
            </Col>
          ))
        ) : (
          <DocumentTemplatesEmptyState />
        )}
      </Row>
    </Drawer>
  );
};
